import { render } from "./ConfirmPasswordResetPage.vue?vue&type=template&id=19c72d84"
import script from "./ConfirmPasswordResetPage.vue?vue&type=script&lang=js"
export * from "./ConfirmPasswordResetPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__